import React, { useState, useEffect } from "react";
import RBPageCotainer from "./RBPageContainer";
import RBMenuElement from "./MenuElement";
import { rbItems } from "./menuItems";
import { motion } from "framer-motion";
import classes from "./styles/style.module.css";

import LogoContainer from "../../assets/images/rb/rb-logo-container.png";
import Logo from "../../assets/images/rb/rb-logo.png";
import { useRoute } from "../../assets/context/RouteContext";

const RB = () => {
  const { previousRoute } = useRoute();
  const [showPreloader, setShowPreloader] = useState(false);

  useEffect(() => {
    if (!previousRoute.includes("rb1403")) {
      setShowPreloader(true)
      setTimeout(() => {
        setShowPreloader(false);
      }, 2000);
    } else {
      setShowPreloader(false);
    }
  }, []);

  return (
    <>
      <RBPageCotainer>
        <div className="row px-3" >
          {rbItems.map((item, index) => {
            const isEven = index % 2 === 0;
            const initialX = isEven ? 50 : -50;
            const delay = index * 0.2 + 2;

            return (
              <motion.div
                key={index}
                className={`col-6 d-flex ${
                  isEven ? "justify-content-start" : "justify-content-end"
                }`}
                initial={{ opacity: 0, x: initialX }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay }}
              >
                <RBMenuElement item={item} />
              </motion.div>
            );
          })}
        </div>
      </RBPageCotainer>
      {showPreloader && (
        <div className={classes.preloader}>
          <div className={classes.rbHeader}>
            <img
              src={LogoContainer}
              alt="rb-bg-container"
              className={classes.headerBgImg}
            />
            <motion.div
              className={classes.rbLogoContainer}
              initial={{ opacity: 0, y: -80 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.7 }}
            >
              <img src={Logo} alt="rb-logo" />
            </motion.div>
          </div>
        </div>
      )}
    </>
  );
};

export default RB;
